import { makeStyles } from "@material-ui/core/styles";

const selectedStyles = makeStyles((theme) => ({
  button: {
    width: "auto",
    minWidth: "auto",
    height: "40px",
    marginRight: "20px",
    background: `linear-gradient(135deg, #0A2540 0%, #143A5E 100%)`,
    fontStyle: "normal",
    color: "white",
    marginLeft: "15px",
    fontWeight: 450,
    fontSize: "15px",
    whiteSpace: "nowrap",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    flexWrap: "nowrap",
    padding: "8px 16px",
    [theme.breakpoints.down("md")]: {
      width: "120px",
      padding: "10px 10px",
      fontSize: "10px",
    },
  },
  textSpan: {
    whiteSpace: "nowrap",
    display: "inline-block",
    flexShrink: 0,
  },
  closeBtn: {
    marginTop: "2px",
    marginLeft: "10px",
    flexShrink: 0,
    display: "inline-flex",
    alignItems: "center",
  },
}));

// eslint-disable-next-line import/prefer-default-export
export { selectedStyles };
